// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import Masthead from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import Display from 'components/display'
import Cover from 'components/cover'
import PrivacyPolicy from 'components/privacyPolicy'
import { Waypoint } from 'react-waypoint'
import { ArticleTeasers, sortMode } from '@ta-interaktiv/react-article-teasers'

const ARTICLE_ID = '25459961'
let teaserIds = ['21862678', '10298012', '25742321', '20618592']
const isMobile = window.innerWidth < 720

function AppComponent() {
  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical fitted segment' style={{ padding: '0' }}>
        <Cover
          title='Voici ce que vos goûts musicaux disent de vous'
          subtitle={
            isMobile
              ? 'À quelle génération sonore appartenez-vous ? Nous analysons votre bibliothèque spotify pour trouver votre âge musical.'
              : 'À quelle génération sonore appartenez-vous ? Nous analysons votre bibliothèque spotify pour trouver votre âge musical.'
          }
        />
        <div className='ui very fitted vertical segment cover-caption'>
          <div className='ui container'>
            <p className='ta secondary caption'>
              Photos: Gettyimages, Keystone. Animation: Mathias Lutz.
            </p>
          </div>
        </div>
      </header>

      <div
        className='ui vertical fitted segment'
        style={{ paddingBottom: '0.5em' }}
      >
        <div className='ui text container'>
          <p className='ta author' style={{ paddingTop: '2em' }}>
            Patrick Meier, Philippe Zweifel et Mathias Lutz
          </p>

          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: 'startReading'
                })
              }
            }}
          />

          <p>
            Les baby-boomers sont-ils plus sages que les millennials? Les
            millenials sont-ils tous des enfants gâtés? Ces étiquettes qui
            collent aux générations sont souvent fausses. Mais nous sommes
            toujours pris dans l’air du temps, comme le rappelle la définition
            sociologique du terme «génération»: groupe d’âge façonné par des
            événements et des influences historiques et sociaux communs.
          </p>
          <p>
            C'est particulièrement vrai pour la musique. Ceux qui ont grandi
            dans les années 80 sont à jamais à l'abri des hits de l'époque. Les
            soixante-huitards assistent encore aujourd'hui aux concerts des
            Stones. Nous avons voulu aller plus loin et nous avons analysé les
            données de Spotify pour savoir en quoi les générations diffèrent
            dans leurs goûts musicaux. Les jeunes écoutent-ils de la musique
            plus positive que les autres? Plus énergique? Et surtout: où vous
            situez-vous dans ces tendances? Quel âge avez-vous musicalement?
            Notre outil interactif vous le dira. Faites le test!
          </p>
          <p>Pour rappel, les générations sont définies comme suit:</p>
          <ul className='gen-definition'>
            <li>
              <strong>GÉNÉRATION Z:</strong> &nbsp;&nbsp;
              {isMobile
                ? 'né en 1994 ou après'
                : 'né en 1994 ou après, âgé de moins de 25 ans'}
            </li>
            <li>
              <strong>GÉNÉRATION Y:</strong> &nbsp;&nbsp;
              {isMobile
                ? 'né entre 1981 et 1994'
                : 'né entre 1981 et 1994, entre 25 et 38 ans'}
            </li>
            <li>
              <strong>GÉNÉRATION X:</strong> &nbsp;&nbsp;
              {isMobile
                ? 'né entre 1965 et 1980'
                : 'né entre 1965 et 1980, entre 39 et 54 ans'}
            </li>
            <li>
              <strong>BABY-BOOMER:</strong> &nbsp;&nbsp;
              {isMobile
                ? 'né entre 1946 et 1964'
                : 'né entre 1946 et 1964, entre 55 et 73 ans'}
            </li>
          </ul>
        </div>
      </div>

      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            /* eslint-disable */
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'vertical-scroll',
              event_label: '25ContentRead'
            })
            /* eslint-enable */
          }
        }}
      />

      {/* START srsly content */}
      <Display />
      {/* END srsly content */}

      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            /* eslint-disable */
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'vertical-scroll',
              event_label: 'contentBottom'
            })
            /* eslint-enable */
          }
        }}
      />

      <div className='ui vertical fitted attached segment'>
        <div className='ui container section'>
          <h4 className='teaser'>Plus d'articles sur ce thème</h4>
          <ArticleTeasers
            sorting='reverse chronologically by creation date'
            numberOfCards='three'
            articleIds={teaserIds}
          />
        </div>
      </div>

      <div className='ui vertical fitted attached segment' id='methodik'>
        <div
          className='ui text container methodik'
          style={{ position: 'relative', paddingTop: '1em' }}
        >
          <h4 style={{ fontSize: '1.4em' }}>Méthode</h4>

          <p>
            Pour chaque chanson, Spotify enregistre différentes caractéristiques
            comme la gaieté ou la dansabilité (
            <a href='https://developer.spotify.com/documentation/web-api/reference/tracks/get-audio-features'>
              Plus d'infos ici
            </a>
            ). Nous avons obtenu de Spotify les 100 chansons les plus écoutées
            par génération (période du 1.4.2018 au 1.4.2019). Les
            caractéristiques ont été obtenues pour chaque titre via l'interface
            de programmation (API) de Spotify accessible au public, permettant
            le calcul des valeurs moyennes pour chaque génération. Ces moyennes
            sont indiquées dans les graphiques linéaires. Toutes les valeurs (à
            l'exception de la longueur du morceau) sont par définition comprises
            entre 0 et 1. Nous avons délibérément omis de spécifier ces valeurs
            sur l'axe des Y, car elles sont très abstraites et peu utiles à
            l'interprétation.
          </p>
          <p>
            Spotify détermine pour chaque utilisateur les chansons qu'il a le
            plus écoutées au cours des 6 derniers mois. Les morceaux écoutés
            récemment sont pondérés plus fortement. Il s'agit de{' '}
            <a href='https://developer.spotify.com/documentation/web-api/reference/personalization/get-users-top-artists-and-tracks'>
              vos 100 meilleures chansons
            </a>
            . Si vous décidez d'analyser vos propres goûts musicaux (via le
            bouton "Participer"), vos 100 meilleurs morceaux seront lus depuis
            votre compte Spotify. Leurs propriétés sont ensuite analysées comme
            pour celles de chaque génération. Les valeurs moyennes sont
            calculées et affichées dans les graphiques (point bleu). En outre,
            les valeurs moyennes de tous les utilisateurs qui ont participé sont
            calculées et affichées (point vert). Vous pouvez ainsi comparer vos
            goûts musicaux avec ceux des différentes générations ainsi qu'avec
            la moyenne de tous les utilisateurs qui ont participé, et vos
            propres valeurs se retrouvent également dans les valeurs de la
            moyenne Tamedia.
          </p>

          <h5>Calcul de l'âge musical</h5>
          <p>
            Pour toutes les propriétés, une régression linéaire sur l'âge a été
            effectuée. Avec les coefficients ainsi obtenus, l'âge peut être
            prédit sur la base de la valeur moyenne d'une certaine propriété.
            Ces valeurs prédites sont limitées à un minimum de 16 ans et un
            maximum de 73 ans. La moyenne de toutes ces valeurs d'âge prédites
            est ensuite calculée. Les valeurs de la chanson vocale, de la
            dansabilité, de la vivacité et de la longueur de la chanson sont
            pondérées deux fois, car elles montrent une tendance
            particulièrement claire pour l'âge. La valeur de l'acoustique, en
            revanche, n'est pas prise en compte car elle ne montre pas de
            tendance claire.
          </p>
          <p>
            Des exemples d'utilisation de l'interface de programmation (API) de
            Spotify pour ces analyses sont à votre disposition sur{' '}
            <a href='https://github.com/tamedia-ddj/Spotify-Musical-Taste'>
              la documentation Github
            </a>
            . Les listes des 100 meilleures chansons des différentes générations
            y sont également disponibles.
          </p>

          <h4 style={{ fontSize: '1.4em' }}>Politique de confidentialité</h4>

          <div className='list'>
            <p>
              Votre vie privée est importante pour nous. Cette déclaration de
              confidentialité indique les données que nous recueillons pour
              l’analyse des goûts musicaux.
            </p>

            <PrivacyPolicy />
          </div>
        </div>
      </div>

      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            /* eslint-disable */
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'vertical-scroll',
              event_label: 'pageBottom'
            })
            /* eslint-enable */
          }
        }}
      />

      <Footer
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          ['Texte, méthode et recherche', 'Patrick Meier, Philippe Zweifel'],
          ['Adaptation pour la suisse romande', 'Fanny Giroud, Mathieu Rudaz'],
          ['Concept et réalisation', 'Mathias Lutz, Interaktiv-Team'],
          [
            'Programmation',
            '<a href="https://www.srsly.ch">SRSLY</a> und Mathias Lutz'
          ]
        ]}
        hidePortfolioTeaser
        mailTo={'daten@tamedia.ch'}
      />
    </div>
  )
}

export default hot(AppComponent)
